import Dropdown from '@components/ui/formElements/Dropdown'
import styles from '../styles.module.scss'
import { AdditionalReasonFieldProps } from './AdditionalReasonField'
import { SetSelectionArgs } from '@components/ui/formElements/Dropdown/List'

export const ReasonDropdown = ({
  field,
  values,
  handleOnAdditionalReasonSelection
}: AdditionalReasonFieldProps) => {
  const handleSelect = (selection: SetSelectionArgs) => {
    const selectedId = selection.reason_dropdown as string

    if (selectedId) {
      handleOnAdditionalReasonSelection([selectedId])
    }
  }

  const reasonList =
    field?.values.map(({ label, value }) => ({ label, value })) || []
  const reasonListValues = reasonList.map(({ value }) => value)
  const selectedReason: string =
    values.reason_detail?.find(id => reasonListValues.includes(id)) || ''

  return (
    <Dropdown
      defaultValue="Please Select"
      placeholder="Please Select"
      classes={`${styles.returnsForm__dropdown} dropdown--wide dropdown__returns`}
      selectedClasses={`dropdown--capitalize dropdown--left ${
        !selectedReason && 'dropdown--grey'
      }`}
      list={reasonList}
      selection={selectedReason}
      setSelection={handleSelect}
      optionClasses="list__option--capitalize list__option--left list__option--returns"
      id="reason_dropdown"
    />
  )
}
